import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_Branching = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Branching: Conditional and Unconditional"
      videos={[
        "https://www.youtube.com/embed/BjOOt2XpMts", // Branch Instructions in 8051 Microcontroller
      ]}
      takeaways={[
        { text: "Branching statements (conditional & unconditional) are essential in almost every 8051 program." },
        { text: "Understand different jump instructions (e.g., LJMP, SJMP, AJMP) and their use cases." },
        { text: "Learn conditional branching instructions like JZ, JNZ, JC, JNC, DJNZ, and how they control program flow." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_Branching;
